import { useEffect, useState } from "react";
import "./styles.css";
import { IoChevronBackOutline, IoHeart } from "react-icons/io5";
import Button from "../Button/Button";
import {
  ProductDataMethodMapping,
  ProductDataSolutionMapping,
} from "../../data/ProductData";
import {
  ProductDataMethodENMapping,
  ProductDataSolutionENMapping,
} from "../../data/ProductDataEn";
import { useTranslation } from "react-i18next";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useUID } from "../../context/UIDContext";
import { useConfig } from "../../context/ConfigContext";
import { IoIosInformation, IoMdHeart, IoMdHeartEmpty } from "react-icons/io";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ProductRecoPage = ({
  onBackClick,
  onSendEmail,
  recommendedData,
  selectedFavorites,
  onFavoriteClick,
  onInfoClick,
  onCheckout,
}) => {
  const { t, i18n } = useTranslation(["recommendation", "aiResults"]);
  const [selectedRoutine, setSelectedRoutine] = useState("kopfhaut");
  const trackEvent = useAmplitude();
  const { uid } = useUID();
  const { userEmail, setUserEmail, isEmailSent } = useConfig();

  const methodData =
    i18n.language === "de"
      ? ProductDataMethodMapping[recommendedData.method]
      : ProductDataMethodENMapping[recommendedData.method];
  const solutionData =
    i18n.language === "de"
      ? ProductDataSolutionMapping[recommendedData.solution]
      : ProductDataSolutionENMapping[recommendedData.solution];
  const finalData = selectedRoutine === "kopfhaut" ? methodData : solutionData;

  const existsFromList = (listItems) => {
    const values = new Set(selectedFavorites.map((item) => item["value"]));
    return listItems.some((item) => values.has(item["value"]));
  };

  const favoritesExist = existsFromList(finalData.Product.items);

  useEffect(() => {
    trackEvent("webapp_user_visited_products_preview_page", uid);
  }, [uid, trackEvent]);

  return (
    <div className="product-page">
      <div className="products-nav-background-image">
        <img
          src="Bg.png"
          alt="Face"
          style={{ width: "100%", objectFit: "contain" }}
        />
      </div>
      <div className="products-nav-background-image-overlay" />
      <div className="product-page-nav">
        <div className="products-back-button-wrapper">
          <IoChevronBackOutline
            className="back-icon"
            onClick={() => {
              trackEvent(
                "webapp_user_back_button_products_preview_page",
                uid,
                "",
                "",
                finalData.Product.title,
              );
              onBackClick();
            }}
          />
        </div>
        <div className="product-page-title">
          <h4 className="product-page-title-text">
            {t("product-page-header-title")}
          </h4>
        </div>
        <div className="products-likes-button-wrapper">
          <div
            className="nav-likes-icon-container"
            onClick={() => {
              if (selectedFavorites.length > 1) {
                trackEvent(
                  "webapp_user_pressed_to_checkout",
                  uid,
                  "",
                  "",
                  "",
                  "",
                  selectedFavorites.length,
                );
                onCheckout();
              }
            }}
          >
            <IoHeart className="nav-likes-icon" />
            <p className="nav-likes-icon-text">{selectedFavorites.length}</p>
          </div>
        </div>
      </div>
      <div className="product-page-white-container">
        <div className="product-page-button-header">
          <button
            className={`product-page-header-button ${selectedRoutine === "kopfhaut" ? "selected" : ""}`}
            onClick={() => {
              trackEvent("webapp_user_pressed_kopfhaut", uid);
              setSelectedRoutine("kopfhaut");
            }}
          >
            {t("recoPage.headerButton.scalp", { ns: "recommendation" })}
          </button>
          <button
            className={`product-page-header-button ${selectedRoutine === "haarpflege" ? "selected" : ""}`}
            onClick={() => {
              trackEvent("webapp_user_pressed_haarpflege", uid);
              setSelectedRoutine("haarpflege");
            }}
          >
            {t("recoPage.headerButton.hair-care", { ns: "recommendation" })}
          </button>
        </div>
        <div className="product-page-content-container">
          <div className="routine-container">
            <div className="routine-boxes">
              <div className="routine-box">
                <h4
                  className="routine-title"
                  style={{
                    borderBottom: `4px solid ${selectedRoutine === "kopfhaut" ? methodData.color : solutionData.color}`,
                  }}
                >
                  {selectedRoutine === "kopfhaut"
                    ? `${t("recoPage.routineBox.scalp-care", { ns: "recommendation" })} ${finalData.Product.title}`
                    : `${t("recoPage.routineBox.hair-care", { ns: "recommendation" })} ${finalData.Product.title}`}
                </h4>
                <p className="routine-description">
                  {finalData.Product.description}
                </p>
                <img
                  src={finalData.Product.image}
                  alt="Routine"
                  className="routine-image"
                  width={100}
                  onClick={() => {
                    trackEvent(
                      "webapp_user_product_info_clicked",
                      uid,
                      "",
                      "",
                      "",
                      finalData.Product.title,
                    );
                    onInfoClick(finalData.Product.items);
                  }}
                />
                <div
                  className="routine-box-like-icon-wrapper"
                  onClick={() => {
                    if (favoritesExist) {
                      onFavoriteClick(finalData.Product.items);
                    } else {
                      trackEvent(
                        "webapp_user_set_liked",
                        uid,
                        "",
                        "",
                        finalData.Product.title,
                      );
                      onFavoriteClick(finalData.Product.items);
                    }
                  }}
                >
                  {favoritesExist ? (
                    <IoMdHeart className="routine-box-like-icon" />
                  ) : (
                    <IoMdHeartEmpty className="routine-box-like-icon" />
                  )}
                </div>
                <div
                  className="routine-box-info-icon-wrapper"
                  onClick={() => {
                    trackEvent(
                      "webapp_user_product_info_clicked",
                      uid,
                      "",
                      "",
                      "",
                      finalData.Product.title,
                    );
                    onInfoClick(finalData.Product.items);
                  }}
                >
                  <IoIosInformation className="routine-box-info-icon" />
                </div>
              </div>
              <div className="routine-box">
                <h4 className="routine-title">
                  {t("recoPage.routineBox.title", { ns: "recommendation" })}
                </h4>
                <p className="routine-description">
                  {finalData.Treatment.description}
                </p>
                <img
                  src={finalData.Treatment.image}
                  alt="Treatment"
                  className="routine-image"
                  width={100}
                />
              </div>
            </div>
            <div className="routine-boxes-button-container">
              <Button
                text={t("recoPage.routineBox.cta", { ns: "recommendation" })}
                onClick={() => {
                  trackEvent(
                    "webapp_user_pressed_to_checkout",
                    uid,
                    "",
                    "",
                    "",
                    "",
                    selectedFavorites.length,
                  );
                  onCheckout();
                }}
                disabled={selectedFavorites.length < 1}
                alternateColor={true}
              />
            </div>
          </div>
          <div className="email-section">
            <h4 className="routine-title">{t("product-email-title")}</h4>
            <p className="routine-description">{t("product-email-detail")}</p>
            <div className="email-input-container">
              <input
                type="text"
                placeholder={t("email-placeholder")}
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                className="email-input-field"
                disabled={isEmailSent}
              />
              <Button
                text={isEmailSent ? t("email-button-sent") : t("email-button")}
                onClick={() => {
                  trackEvent("webapp_user_press_product_preview_email", uid);
                  onSendEmail(true);
                }}
                disabled={isEmailSent || !emailRegex.test(userEmail)}
                alternateColor={true}
              />
            </div>
          </div>
        </div>
        <div className="bottom-logos">
          <h4 className="bottom-log-title">The Culture of Beauty</h4>
          <img
            src="logo-inverted.png"
            alt="La Biosthetique"
            width={100}
            className="bottom-logo-img"
          />
        </div>
      </div>
    </div>
  );
};
